// extracted by mini-css-extract-plugin
export default {"container":"network-access_container__MBWZ4"};